import { render, staticRenderFns } from "./FeatureLabel.vue?vue&type=template&id=0bdf8980"
import script from "./FeatureLabel.vue?vue&type=script&lang=ts"
export * from "./FeatureLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports